// Tabs/TabPanelContent.pharmacology.tsx
import React from 'react';
import MetabolitesTableCard from '../components/tabs/pharmacology/MetabolitesTable';
import PharmacoDynamicsTable from '../components/tabs/pharmacology/PharmacoDynamicsTable';
import PKTableCard from '../components/tabs/pharmacology/PKTable';
import PKIndicesTableCard from '../components/tabs/pharmacology/PKIndicesTable';
import MetaboliteCard from '../components/tabs/pharmacology/Metabolite';
import PharmacoDynamicsCard from '../components/tabs/pharmacology/PharmacoDynamics';
import PKCard from '../components/tabs/pharmacology/PK';
import PKIndicesCard from '../components/tabs/pharmacology/PKIndices';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentPharmacology: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <MetabolitesTableCard header={'Metabolites'} eventGroupToTrigger={'pharmacology'} />
            <PharmacoDynamicsTable header={'Pharmaco Dynamics Table'} eventGroupToTrigger={'pharmacology'} />
            <PKTableCard header={'PK'} eventGroupToTrigger={'pharmacology'} />
            <PKIndicesTableCard header={'PK Indices'} eventGroupToTrigger={'pharmacology'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="pharmacology" />
        </div>
        <div className="col-3 col-sm-3">
            <MetaboliteCard header={'Metabolite'} eventGroupToTrigger={'pharmacology'} />
            <PharmacoDynamicsCard header={'Pharmaco Dynamics'} eventGroupToTrigger={'pharmacology'} />
            <PKCard header={'PK'} eventGroupToTrigger={'pharmacology'} />
            <PKIndicesCard header={'PK Indices'} eventGroupToTrigger={'pharmacology'} />
        </div>
    </div>
);

export default TabPanelContentPharmacology;
